import moment from 'moment'

export function isTokenExpired(token: string): boolean {
    const header = token.split('.')[0]
    const decodeBase64 = Buffer.from(header, 'base64').toString()
    const obj = JSON.parse(decodeBase64)

    const exp = moment().isSameOrAfter(
        obj.EXP ? moment(obj.EXP) : moment(obj.exp)
    )

    return exp
}
